// JADx Cash configuration — the payment provider for CheF SKN.
// Currency is XCD only, amounts are sent to JAD as decimal strings in XCD.
// No currency conversion is performed (previously converted XCD→USD for Stripe).
export const JadConfig = {
  currency: 'XCD',
  merchantCountryCode: 'KN',
};

// Utility functions
export const formatCurrencyXCD = (amount) => {
  return `$${amount?.toFixed(2) || '0.00'}`;
};

export const toJadAmount = (amountXCD) => {
  return Number(amountXCD).toFixed(2);
};
